import $ from "jquery";

/**
 * Submenu
 *
 * Foundation Magellan scrolls to a section and marks the item of the section in view with
 * `s_active` (see submenu.twig). This file fills in what Magellan leaves out.
 */

const $magellan = $(".sb_submenu_links[data-magellan]");

/**
 * Event handler - mirror the active item to assistive tech
 */
$magellan.on("update.zf.magellan", function (e, $active) {
    $(this).find("[aria-current]").removeAttr("aria-current");
    $active.attr("aria-current", "location");
});

/**
 * Event handler - keep the section in the URL, as the old hash-click buttons did
 *
 * Only `click`: `tap` fires alongside it on touch and would push the same entry twice. pushState
 * fires no `hashchange`, so go-to-by-scroll.js doesn't scroll a second time.
 */
$magellan.on("click", "a[href^='#']", function () {
    history.pushState(null, "", this.getAttribute("href"));
});

/**
 * Run on page load - re-measure the sections whenever the page changes height
 *
 * Magellan only measures on load and resize. Opening the itinerary or the accommodations, or a
 * lazy image arriving, moves every section below it — and then the wrong item lights up.
 */
$(function () {
    if ($magellan.length === 0 || !("ResizeObserver" in window)) {
        return;
    }

    let frame = null;

    new ResizeObserver(() => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
            // Not there until app.js has run $(document).foundation()
            $magellan.data("zfPlugin")?.reflow();
        });
    }).observe(document.body);
});
